// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"CarHireOption-desktop__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/CarHire/CarHireOption.desktop.scss
 ** module id = 896
 ** module chunks = 1
 **/